import { App } from "antd"
import React, { useState } from "react"
import { useNavigate } from "react-router"

import { RoutesPaths } from "../../../constants/routes.ts"
import { useAppDispatch } from "../../../hooks/use-app-dispatch.ts"
import type { BasePagination } from "../../../types/api.ts"
import { fetchTeamMembers } from "../../TeamManagementPage/redux/team-members.thunks.ts"
import type { TeamMembersFilters } from "../../TeamManagementPage/redux/team-members.types.ts"
import type { TeamMember } from "../../TeamManagementPage/types/types.ts"
import { fetchUserInfo } from "../../User/redux/user.thunks"
import { transferGccOwnership } from "../redux/permissions.thunks.ts.ts"
import { TransferOwnershipModal } from "./TransferOwnershipModal.tsx"

interface TransferOwnershipModalControllerProps {
  onClose: () => void
  onSuccess?: () => void
}

export function TransferOwnershipModalController({
  onClose,
  onSuccess
}: TransferOwnershipModalControllerProps) {
  const { modal } = App.useApp()
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const [isTransferring, setIsTransferring] = useState(false)

  const handleGetUsers = async (
    params: Partial<TeamMembersFilters>
  ): Promise<BasePagination<TeamMember>> => {
    const data = await dispatch(
      fetchTeamMembers({ ...params, q: params?.q ?? null, page_size: 10 })
    ).unwrap()

    return {
      ...data,
      results: data?.results ?? []
    }
  }

  const handleTransferOwnership = (newOwnerUserId: string) => {
    modal.confirm({
      title: "Are you absolutely sure?",
      content:
        "This will permanently transfer GCC ownership. This action cannot be undone.",
      okText: "Yes, Transfer",
      okButtonProps: { danger: true },
      cancelText: "Cancel",
      onOk: async () => {
        setIsTransferring(true)
        try {
          await dispatch(
            transferGccOwnership({ new_owner_user_id: newOwnerUserId })
          ).unwrap()
          await dispatch(fetchUserInfo())

          if (onSuccess) {
            onSuccess()
            return
          }

          navigate(RoutesPaths.home)
        } finally {
          setIsTransferring(false)
        }
      }
    })
  }

  return (
    <TransferOwnershipModal
      open
      transferring={isTransferring}
      onClose={onClose}
      getUsers={handleGetUsers}
      onConfirm={handleTransferOwnership}
    />
  )
}
